import React, { useEffect, useState } from "react";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TextField, Button } from "@mui/material";
import { URLS } from "../../helpers/URLS";
import useAxios from "../../helpers/Hooks/useAxios";
import Accordion from 'react-bootstrap/Accordion';
import SkeletonLoader from "../../loaders/Skeleton";
import NoData from "../../loaders/NoData";
import AddStatus from "./AddStatus";
import dayjs from 'dayjs';
import moment from "moment";
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import '../../assets/scss/tables.scss';
import { toast } from 'react-toastify';
import '../../App.scss'

const statusObj = {
    projectID: "",
    activityID: "",
    hours: 0,
    status: "",
    description: ""
}

const DailyStatus = () => {

    const { fetchData } = useAxios();
    const [loadSkeleton, setLoadSkeleton] = useState(true);
    const [isStatusModel, setIsStatusModel] = useState(false);
    const [isNodata, setNodata] = useState(false);
    const [searchParameters, setSearchParameters] = useState({
        startDate: new Date(moment().subtract(10, 'days').format('YYYY-MM-DD')),
        endDate: new Date()
    });
    const [activitiesList, setActivitiesList] = useState([]);
    const [assignedProjectList, setAssignedProjectList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [statusPayload, setStatusPayload] = useState({
        date: dayjs(new Date()),
        dailystatusID: "",
        List: [{ ...statusObj }]
    })

    const getActivitiesList = async () => {
        try {
            const resp = await fetchData({ url: URLS.getActivities, method: 'get' });
            if (resp.status === 200) {
                setActivitiesList(resp.data)
            }
        } catch (error) {
            console.log(error);
        }
    }

    const getAssignedProjectsList = async () => {
        try {
            const resp = await fetchData({ url: URLS.getAssignedProjects, method: 'get' });
            if (resp.status === 200) {
                setAssignedProjectList(resp.data)
            }
        } catch (error) {
            console.log(error);
        }
    }
    const getDailyStatusdownload = async () => {
        try {          
            const start = searchParameters.startDate && moment(searchParameters.startDate).isValid() ? moment(searchParameters.startDate).format('YYYY-MM-DD') : '';
            const end = searchParameters.endDate && moment(searchParameters.endDate).isValid() ? moment(searchParameters.endDate).format('YYYY-MM-DD') : '';
            const resp = await fetchData({ url: `${URLS.getDailyStatusdownload}?startDate=${start}&endDate=${end}`, method: 'get' });
            if (resp.status === 200) {
                window.open(`${URLS.fileDownloadServer}${resp.data.location}/${resp.data.fileName}`);
                setNodata(true);
            } 
            else 
            {
                toast.error(resp.message || 'Error downloading file');
            }
        } catch (error) {
            console.log(error);
        }
    }

    const getDailyStatus = async () => {
        try {
            setLoadSkeleton(true);
            const start = searchParameters.startDate && moment(searchParameters.startDate).isValid() ? moment(searchParameters.startDate).format('YYYY-MM-DD') : '';
            const end = searchParameters.endDate && moment(searchParameters.endDate).isValid() ? moment(searchParameters.endDate).format('YYYY-MM-DD') : '';
            const resp = await fetchData({ url: `${URLS.getDailyStatus}?startDate=${start}&endDate=${end}`, method: 'get' });
            if (resp.status === 200) {
                setStatusList(resp.data);
                setLoadSkeleton(false);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const modelHandle = () => {
        setIsStatusModel(!isStatusModel)
    }

    useEffect(() => {
        getActivitiesList();
        getAssignedProjectsList();
        getDailyStatus();
    }, [searchParameters.startDate, searchParameters.endDate]);

    return (
        <div className="wh-table">
            <div className="wh-toolbar">
                <h4 className="title">My Work Reports</h4>
                <Button type="button" variant="contained" className="wh-toolbar-action"
                    startIcon={<AddRoundedIcon />}
                    onClick={(e) => {
                        setStatusPayload({
                            date: new Date(),
                            dailystatusID: "",
                            List: [{ ...statusObj }]
                        })
                        modelHandle();
                    }}>Add Status</Button>
            </div>

            {/* One filter bar that wraps, rather than a second copy of it for
                small screens that had drifted out of step with this one. */}
            <div className="wh-filter-bar">
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                        label="Start Date"
                        inputFormat="DD/MM/YYYY"
                        value={searchParameters.startDate}
                        maxDate={new Date()}
                        onChange={(date) => {
                            const validDate = date && date.toDate ? date.toDate() : date;
                            setSearchParameters(prev => ({ ...prev, startDate: validDate }));
                        }}
                        renderInput={(params) => <TextField {...params} size="small" required />}
                    />
                </LocalizationProvider>

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                        label="End Date"
                        inputFormat="DD/MM/YYYY"
                        value={searchParameters.endDate}
                        minDate={searchParameters.startDate}
                        maxDate={new Date()}
                        onChange={(date) => {
                            const validDate = date && date.toDate ? date.toDate() : date;
                            setSearchParameters(prev => ({ ...prev, endDate: validDate }));
                        }}
                        renderInput={(params) => <TextField {...params} size="small" required />}
                    />
                </LocalizationProvider>

                <Button variant="contained" startIcon={<SearchRoundedIcon />}
                    onClick={(e) => { getDailyStatus(); }}>Search</Button>

                <Button variant="outlined" startIcon={<DownloadRoundedIcon />}
                    className="wh-filter-bar-end"
                    disabled={statusList.length ? false : true}
                    onClick={(e) => { getDailyStatusdownload(); }}>Download</Button>
            </div>

            {loadSkeleton ?
                <SkeletonLoader /> : (statusList.length > 0 ?
                    <Accordion defaultActiveKey="0" className="wh-accordion">
                        {statusList.map((row, index) => {

                            const hours = row.data.reduce((sum, item) => sum + Number(item.hours || 0), 0);

                            return (
                                <Accordion.Item key={index} eventKey={index}>
                                    <Accordion.Header>
                                        <span className="wh-day-date">
                                            <CalendarMonthOutlinedIcon />
                                            {moment(row.date).format('DD MMMM YYYY')}
                                        </span>
                                        <span className="wh-day-meta">
                                            <span className="wh-pill">{row.data.length} {row.data.length === 1 ? 'entry' : 'entries'}</span>
                                            <span className="wh-pill wh-pill-good">{hours} {hours === 1 ? 'hour' : 'hours'}</span>
                                        </span>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <div className="wh-day-actions">
                                            <Button type="button" variant="outlined" startIcon={<EditOutlinedIcon />}
                                                onClick={e => {
                                                    setStatusPayload({
                                                        date: new Date(row.data[0].date),
                                                        dailystatusID: row.data[0].dailystatusID,
                                                        List: row.data.map(item => {
                                                            return {
                                                                projectID: item.projectID,
                                                                activityID: item.activityID,
                                                                hours: item.hours,
                                                                status: item.status,
                                                                description: item.description
                                                            }
                                                        })
                                                    })
                                                    modelHandle();
                                                }}>Edit</Button>
                                        </div>

                                        <div className="table-responsive wh-table-shell">
                                            <table className="table">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">#</th>
                                                        <th scope="col">Project Name</th>
                                                        <th scope="col">Activity Name</th>
                                                        <th scope="col">Hours</th>
                                                        <th scope="col">Description</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {row.data.map((s, subIndex) => <tr key={subIndex}>
                                                        <td>{subIndex + 1}</td>
                                                        <td>{s.project.projectName}</td>
                                                        <td>{s.Activity.activityName}</td>
                                                        <td className="text-nowrap">{s.hours}</td>
                                                        <td className="wh-cell-muted">{s.description}</td>
                                                    </tr>
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </Accordion.Body>
                                </Accordion.Item>
                            );
                        })}
                    </Accordion>
                    : <NoData />
                )
            }

            <AddStatus isStatusModel={isStatusModel} modelHandle={modelHandle} statusPayload={statusPayload} setStatusPayload={setStatusPayload} statusObj={statusObj} assignedProjectList={assignedProjectList} activitiesList={activitiesList} getDailyStatus={getDailyStatus} />
        </div>
    );
}

export default DailyStatus;
